import {Injectable} from "@angular/core";
import {CustomHttpService} from "./CustomHttp.service";
import {ResponseResult} from "../shared/ResponseResult";
import {API_CONSTANTS} from "../common/constant/ApiConstants";
import {ApplicationList} from "../shared/ApplicationList";
import {Observable} from "rxjs/Rx";
import {ApplicationItem} from "../shared/ApplicationItem";
import {RequestResult} from "../shared/RequestResult";
import {AppPendingApplications} from "../shared/AppPendingApplications";
import {Ethnicity} from "../shared/Ethnicity";
import { State} from "../shared/State";
import {ListOfInfo} from "../shared/ListOfInfo";
import {CreditCard} from "../shared/CreditCard";
import {Country} from "../shared/Country";
import { FeatureSemesterDateVO } from "app/shared/FeatureSemesterDateVO";
import { Program } from "app/shared/Program";
import { TIUSite } from "app/shared/TIUSite";
import { InstitutionSFVO } from "app/shared/InstitutionSFVO";
@Injectable()
export class ApplicationService {
  constructor(private customHttpService: CustomHttpService) {}

  // get application list
  getApplicationList(requestResult: RequestResult<ApplicationList>):Observable<ResponseResult<ApplicationList>> {
      return this.customHttpService.post(API_CONSTANTS.GET_LIST_OF_APPLICATION,JSON.stringify(requestResult));
  }

  // Pending *****
  deleteApplication(applicationList: ApplicationItem):Observable<ResponseResult<ApplicationItem>> {
    return this.customHttpService.post(API_CONSTANTS.DELETE_APPLICATION,JSON.stringify(ApplicationItem));
  }
  // Open application , Open in-complete application
  openApplication(requestResult: RequestResult<AppPendingApplications>):Observable<ResponseResult<AppPendingApplications>> {
    return this.customHttpService.post(API_CONSTANTS.GET_APPLICATION_INFO,JSON.stringify(requestResult));
  }

  // Open PDF
  openApplicationPDF(requestResult: RequestResult<any>):Observable<any> {
    return this.customHttpService.postblob(API_CONSTANTS.GET_APPLICATION_PDF,JSON.stringify(requestResult));
  }

  // save application
  saveApplication(appPendingApplications: AppPendingApplications):Observable<ResponseResult<AppPendingApplications>> {
    return this.customHttpService.post(API_CONSTANTS.SAVE_APPLICATION_INFO,JSON.stringify(appPendingApplications));
  }

  // submit application
  submitApplication(creditCard: CreditCard):Observable<ResponseResult<CreditCard>> {
    return this.customHttpService.post(API_CONSTANTS.SUBMIT_APPLICATION_INFO,JSON.stringify(creditCard));
  }
  // InActive current application, used when create new JD/MLS Application and old one is In-Completed

  inActiveCurrentApplication(requestResult: RequestResult<AppPendingApplications>):Observable<ResponseResult<AppPendingApplications>> {
    return this.customHttpService.post(API_CONSTANTS.IN_ACTIVE_CURRENT_APPLICATION,JSON.stringify(requestResult));
  }

  //[[ ========== Load Common Info:  Ethnicity, List Of Info, State ===========
  // Get Ethnicity
  getEthnicityList():Observable<ResponseResult<Ethnicity>> {
    return this.customHttpService.get(API_CONSTANTS.GET_ETHNICITY);
  }

  // Get List Of Info
  getListOfInfoList():Observable<ResponseResult<ListOfInfo>> {
    return this.customHttpService.get(API_CONSTANTS.GET_LIST_OF_INFO);
  }

  // Get States
  getStateList():Observable<ResponseResult<State>> {
    return this.customHttpService.get(API_CONSTANTS.GET_STATE);
  }

  // Get programs
  getProgramList():Observable<ResponseResult<Program>> {
    return this.customHttpService.get(API_CONSTANTS.GET_PROGRAM_LIST);
  }

  // Get TIUSite
  getTIUSiteList():Observable<ResponseResult<TIUSite>> {
    return this.customHttpService.get(API_CONSTANTS.GET_TIU_SITE_LIST);
  }

  // Get Country
  getCountryList():Observable<ResponseResult<Country>> {
    return this.customHttpService.get(API_CONSTANTS.GET_COUNTRY);
  }

  // get application list
  mlmProgramStartDateForAdmissionStatus(requestResult: RequestResult<String>):Observable<any> {
    return this.customHttpService.post(API_CONSTANTS.MLM_PROGRAM_START_DATE_FOR_ADMISSION_STATUS,JSON.stringify(requestResult));
  }

  getFeatureSemesterDate(requestResult: RequestResult<String>): Observable<any> {
    return this.customHttpService.post(API_CONSTANTS.GET_FEATURE_SEMESTER_DATE, JSON.stringify(requestResult));
  }

  getFeatureSemesterDateFromSF(requestResult: RequestResult<String>): Observable<any> {
    return this.customHttpService.post(API_CONSTANTS.GET_FEATURE_SEMESTER_DATE_SF, JSON.stringify(requestResult));
  }

  getApplicationSuccessInfo(requestResult: RequestResult<String>):Observable<any> {
    return this.customHttpService.post(API_CONSTANTS.GET_APPLICATION_SUCCESS_INFO, JSON.stringify(requestResult));
  }
  //=============================]]

  // Code Added By Heta Patel- 179367150
  getTLSTableOfTableData(objectParam: Object): Observable<ResponseResult<string>> {
    return this.customHttpService.post(API_CONSTANTS.GET_TLS_TABLE_OF_TABLE, JSON.stringify(objectParam));
  }

  getInstitutionListFromSF():Observable<ResponseResult<InstitutionSFVO[]>> {
    return this.customHttpService.get(API_CONSTANTS.GET_INSTITUTION_LIST_FROM_SF);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/application.service.ts